import React, { useMemo } from 'react'
import clsx from 'clsx'
import { useStyles } from './ButtonLogoAvailabilityForm.styles'
import { Typography } from '@mui/material'
import {
  RadioButtonGroupMapping,
  RadioButtonsV2,
  RadioButtonType,
  SwitchV2,
  SwitchVarient,
} from '@labrav/react-components'
import { useFormikContext } from 'formik'
import { awsBlackLogo, awsWhiteLogo } from '../../../../common/utils/constants'
import { useStyles as commonStyles } from '../../FlyOutStorefront.styles'
import { ButtonInCreation } from '../../../../modules/storefront/buttonCreation/reducer'
import { isBoolean } from 'lodash'

export const ButtonLogoAvailability: React.FC = () => {
  const { classes } = useStyles()
  const { classes: commonClasses } = commonStyles()

  const { values, setFieldValue } = useFormikContext<ButtonInCreation>()
  const { buttonData } = values
  const isAWSLogoShow = isBoolean(buttonData?.shouldShowAwsLogo)
    ? buttonData?.shouldShowAwsLogo
    : false
  const handleChangeLogoShow = (e: {
    target: {
      checked: boolean
    }
  }) => {
    setFieldValue('buttonData.shouldShowAwsLogo', e?.target?.checked)
  }

  const logoOptions: RadioButtonGroupMapping[] = [
    {
      key: 'Black',
      label: 'Black',
      type: RadioButtonType.STANDARD,
      disabled: false,
    },
    {
      key: 'White',
      label: 'White (On dark backgrounds)',
      type: RadioButtonType.STANDARD,
      disabled: false,
    },
  ]
  const checkedValue = useMemo(() => {
    return buttonData.buyWithAwsLogoUrl === awsWhiteLogo ? 'White' : 'Black'
  }, [buttonData.buyWithAwsLogoUrl])

  const handleSelection = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValue = (event.target as HTMLInputElement).value
    const url = selectedValue === 'White' ? awsWhiteLogo : awsBlackLogo

    await setFieldValue('buttonData.buyWithAwsLogoUrl', url)
  }

  return (
    <>
      <div
        className={clsx(
          classes.container,
          classes.sectionWrapper,
          classes.name
        )}
        data-testid="card-container"
      >
        <div className={classes.toggleWrapper}>
          <Typography
            data-testid="header-title"
            className={classes.headerTitle}
          >
            Available in AWS Marketplace logo
          </Typography>
          <SwitchV2
            data-testid="logo-switch"
            checked={isAWSLogoShow}
            switchVarient={SwitchVarient.DARK}
            onChange={handleChangeLogoShow}
          />
        </div>

        <Typography
          data-testid="section-title"
          className={classes.sectionTitle}
        >
          Add AWS approved branding with the button for a better user experience
          and authenticity.
        </Typography>

        <div className={classes.radioWidth}>
          <RadioButtonsV2
            name={'buttonData.buyWithAwsLogoUrl'}
            handleChange={handleSelection}
            checkedValue={{
              key: checkedValue,
              value: checkedValue,
            }}
            radioButtonMappings={logoOptions}
          />
        </div>
      </div>
    </>
  )
}
